export default "__VITE_ASSET__DcZM5sId__"